import React from 'react';

export class ELShirt extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="elshirt">
          <h1>Golden Gate Bridge EL Wire Shirt</h1>
          <p>This was a combo job with my husband and I working together</p>

          <p>Our friends convinced us to go to the music festival Electric Daisy Carnival (EDC) in Las Vegas one year.</p>

          <p>Were convinced to make something glowing to wear while there.</p>

          <p>My husband found EL wire and was especially excited about the 'marching ants' EL wire, and wanted to make the Golden Gate Bridge with blue/red marching wire to represent the different directions of cars across the bridge.</p>

          <p>He found the parts and ordered everything, and I helped him put it together onto a shirt.</p>
          
          <p>Projects with your partners is definitely a test of communication and patience and a big goal of really wanting to keep loving the person afterwards.</p>

          <p>Ended up making a paper template of the golden gate bridge and used... hot glue? to try to keep the lines straight as we stabbed holes through the shirt and threaded the EL wire through to make it 'disappear.'</p>

          <p>Came out really well at the end!</p>

          <img src="../../assets/elShirt.jpg" alt="Man facing away from the camera with a depiction of the Golden Gate Bridge with thin orange wires."></img>

        </div>
    );
  }
}
